<svg id="b" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <g id="c" data-name="Titles">
    <g>
      <rect width="64" height="64" fill="none"/>
      <path class="filled" d="M49.164,17.695H14.836c-1.657,0-3,1.343-3,3v22.609c0,1.657,1.343,3,3,3H49.164c1.657,0,3-1.343,3-3V20.695c0-1.657-1.343-3-3-3Zm-1.391,4l-15.773,11.428-15.772-11.428h31.544Zm.391,19.609c0,.552-.448,1-1,1H16.836c-.552,0-1-.448-1-1v-14.891l14.957,10.812c.713,.539,1.698,.539,2.411,0l14.958-10.812v14.891Z" fill="#70a3e0"/>
    </g>
  </g>
</svg>